import React from 'react';
import { TabPanel, Text } from "@chakra-ui/react";

const Users = () => {
    return (
        <TabPanel>
            <Text>Users</Text>
        </TabPanel>
    );
};

export default Users;